var React = require('react');

function FlagGr (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"#f5f5f5","key":0},React.createElement("path",{"d":"M0 125.551h512v37.27H0zM0 200.091h512v37.27H0zM0 274.641h512v37.27H0z"})),React.createElement("path",{"fill":"#41479b","d":"M0 311.911h512v37.27H0z","key":1}),React.createElement("path",{"fill":"#f5f5f5","d":"M0 349.181h512v37.27H0z","key":2}),React.createElement("g",{"fill":"#41479b","key":3},React.createElement("path",{"d":"M8.828 423.725h494.345a8.829 8.829 0 008.828-8.828v-28.445H0v28.445a8.828 8.828 0 008.828 8.828zM512 125.549V97.104a8.829 8.829 0 00-8.828-8.828H8.828A8.83 8.83 0 000 97.104V274.637h512v-37.272H176.552v-37.272H512v-37.272H176.552v-37.272H512z"})),React.createElement("path",{"fill":"#f5f5f5","d":"M176.552 162.821h-69.64V88.277H69.64v74.544H0v37.272h69.64v74.544h37.272v-74.544h69.64z","key":4})]);
}

FlagGr.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagGr;

FlagGr.default = FlagGr;
